import React from "react"
import "./OnboardingStepper.scss"

/**
 * Presentational 5-step onboarding progress bar shared by the onboarding modals.
 * Each step declares its own state: "done" | "active" | "skipped" | "upcoming".
 */
const OnboardingStepper = ({ steps }) => (
  <div className="ob-stepper">
    {steps.map((step, i) => (
      <div className={`ob-step ob-step--${step.state}`} key={step.label}>
        <div className="ob-step-top">
          <span className={`ob-line ${i === 0 ? "ob-line--hidden" : ""}`} />
          <div className="ob-circle">{i + 1}</div>
          <span className={`ob-line ${i === steps.length - 1 ? "ob-line--hidden" : ""}`} />
        </div>
        <div className="ob-step-label">{step.label}</div>
      </div>
    ))}
  </div>
)

export default OnboardingStepper
